module.exports = __webpack_public_path__ + "img/keendetailbanner.48afa11e.png";